export const CONFIGURATOR_WALL_NO_COLORS_TEXT = 'Не выбрано';
// важно, чтобы было именно 6 букв в hex, для корректной работы с колор пикером
export const CONFIGURATOR_WALL_COLOR_DEFAULT = '#ffffff';
